import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      className="toaster-group"
      offset="calc(1rem + env(safe-area-inset-bottom))"
      mobileOffset={{ bottom: 'calc(1rem + env(safe-area-inset-bottom))' }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster-group]:bg-background group-[.toaster-group]:text-foreground group-[.toaster-group]:border-border group-[.toaster-group]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
    />
  );
}
